module.exports = __webpack_public_path__ + "assets/img/logitech-becomethenextcreator-w720.ac75a1e9.jpg";